export enum EDowngradeStep {
  ADS_PROVIDER = 'ADS_PROVIDER',
  FACEBOOK_AD_CREDENTIALS = 'FACEBOOK_AD_CREDENTIALS',
  INVITED_MEMBERS = 'INVITED_MEMBERS',
}
